import { fieldsOf } from 'constants/kpiBuilderCatalogue';
import { CustomMeasure, MetricAgg } from 'helpers/kpiBuilder/types';
import { BuilderSection } from './BuilderSection';
import { FieldPicker } from './FieldPicker';
import { OptionCards } from './OptionCards';
import { OptionChips } from './OptionChips';
import { StepProps } from './StepProps';
import { TextBox } from './TextBox';

const CUSTOM_CARD = { id: 'custom', label: 'Another value…', desc: 'Choose any field and how to combine it, for example the average or total of a number.' };
const AGGS = [
  { id: 'value_count', label: 'Count' }, { id: 'cardinality', label: 'Unique count' }, { id: 'sum', label: 'Total' },
  { id: 'avg', label: 'Average' }, { id: 'min', label: 'Smallest' }, { id: 'max', label: 'Largest' },
];
const DIVISORS = [
  { id: 1, label: 'As it is' }, { id: 60, label: '÷ 60' }, { id: 1000, label: '÷ 1,000' }, { id: 60000, label: '÷ 60,000 (milliseconds to minutes)' },
];

// What to count. The catalogue's measures are offered first; any other field can be combined by hand.
export const MeasureStep = ({ a, s, patch }: StepProps) => {
  const m = a.custom.measure;
  const set = (next: Partial<CustomMeasure>) => patch({ custom: { ...a.custom, measure: { ...m, ...next } } });

  return (
    <BuilderSection title="Count what?" hint="Decide what one unit is. People are counted once each; records are counted every time they appear.">
      <OptionCards cards={[...s.measures, CUSTOM_CARD]} selected={a.measure ? [a.measure] : []} onSelect={(id) => patch({ measure: id })} />
      {a.measure === 'custom' && (
        <div className="border rounded p-3 mt-3 bg-white">
          <OptionChips options={AGGS} selected={[m.agg]} onSelect={(id) => set({ agg: id as MetricAgg })} />
          <FieldPicker fields={fieldsOf(a.src)} value={m.field} placeholder="Field to combine, e.g. ratingScore" onChange={(field) => set({ field })} />
          <div className="mt-2">
            <TextBox value={m.label} placeholder="Name shown on the chart, e.g. Average rating" onChange={(label) => set({ label })} />
          </div>
          {['avg', 'sum', 'min', 'max'].includes(m.agg) && (
            <div className="mt-2">
              <OptionChips options={DIVISORS} selected={[m.divisor]} onSelect={(id) => set({ divisor: Number(id) })} />
            </div>
          )}
        </div>
      )}
    </BuilderSection>
  );
};
